import { render, staticRenderFns } from "./CheckBoxList.vue?vue&type=template&id=232d0ad5&"
import script from "./CheckBoxList.vue?vue&type=script&lang=ts&"
export * from "./CheckBoxList.vue?vue&type=script&lang=ts&"
import style0 from "./CheckBoxList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports